import angular from 'angular';
import swal from 'sweetalert';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

    getFields(){
        return {
            sifra: {
                key: 'sifra',
                type: 'hInput',
                templateOptions: {
                    label: 'Šifra',
                    required: true
                }
            },

            naziv: {
                key: 'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv',
                    required: true
                }
            }
        };
    }
}

FormController.$inject = ['Dijagnoza'];

export default FormController;



// WEBPACK FOOTER //
// ./app/components/dijagnoza/form/form.controller.js